import React, { createContext, useEffect, useState } from 'react'
import app from '../firebase/firebase.config.js';
import { createUserWithEmailAndPassword, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';

export const AuthContext =createContext();

const auth=getAuth(app);

const  AuthProvider=({children}) =>{
  const [user,setUser]=useState(null);
  const [loading,setLoading]=useState(true);

  const createUser =(email, password)=>{
    setLoading(true);
    return createUserWithEmailAndPassword(auth,email,password);

  }

  const login=(email, password)=>{
    setLoading(true);
    return signInWithEmailAndPassword(auth, email, password)
  }

  const logout=()=>{
    return signOut(auth)
  }

  useEffect(()=>{
    const unsubscribe=onAuthStateChanged(auth,currentUser =>{
      // console.log(currentUser);
      setUser(currentUser)
      setLoading(false);
    });
    return ()=>{
      return unsubscribe();
    }
  },
  []);

  const authInfo={
    user,
    createUser,
    loading,
    login,
    logout
  }
  return (
    <AuthContext.Provider value={authInfo}>
         {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider